import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/views/Index'
import Epgs from '@/views/Epg/Epgs'
import Epg from '@/views/Epg/Epg'
import TvProgram from '@/views/TvProgram'
import Shows from '@/views/Show/Shows'
import Show from '@/views/Show/Show'
import Labels from '@/views/Label/Labels'
import Label from '@/views/Label/Label'
import Languages from '@/views/Language/Languages'
import Language from '@/views/Language/Language'
import Countries from '@/views/Country/Countries'
import Country from '@/views/Country/Country'
import StationGroups from '@/views/StationGroup/StationGroups'
import StationGroup from '@/views/StationGroup/StationGroup'
import TvStations from '@/views/TvStation/TvStations'
import TvStation from '@/views/TvStation/TvStation'
import Broadcast from '@/views/Broadcast'
import TvChannels from '@/views/TvChannel/TvChannels'
import TvChannel from '@/views/TvChannel/TvChannel'
import EpgSources from '@/views/EpgSource/EpgSources'
import EpgSource from '@/views/EpgSource/EpgSource'
import Crons from '@/views/Cron/Crons'
import Cron from '@/views/Cron/Cron'
import CronRunLog from '@/views/Cron/CronRunLog'
import ImageSizes from '@/views/ImageSize/ImageSizes'
import ImageSize from '@/views/ImageSize/ImageSize'
import Users from '@/views/User/Users'
import User from '@/views/User/User'
import Settings from '@/views/Settings'
import PairingTemplates from '@/views/PairingTemplate/PairingTemplates'
import VideoQualities from '@/views/VideoQuality/VideoQualities'
import Currencies from '@/views/Vod/Currency/Currencies'
import Currency from '@/views/Vod/Currency/Currency.vue'
import Providers from '@/views/Vod/Provider/Providers.vue'
import Provider from '@/views/Vod/Provider/Provider.vue'
import Videos from '@/views/Vod/Video/Videos.vue'
import Video from '@/views/Vod/Video/Video.vue'
import Packages from '@/views/Vod/Package/Packages.vue'
import Package from '@/views/Vod/Package/Package.vue'
import Backoffices from '@/views/Backoffice/Backoffices.vue'
import Backoffice from '@/views/Backoffice/Backoffice.vue'
import BlackoutContents from '@/views/BlackoutContent/BlackoutContents.vue'
import BlackoutContent from '@/views/BlackoutContent/BlackoutContent.vue'
import BlackoutContentTemplates from '@/views/BlackoutContentTemplate/BlackoutContentTemplates.vue'
import BlackoutContentTemplate from '@/views/BlackoutContentTemplate/BlackoutContentTemplate.vue'
import MaturityRatings from '@/views/MaturityRating/MaturityRatings.vue'
import MaturityRating from '@/views/MaturityRating/MaturityRating.vue'

Vue.use(Router)

const AUTH_LOGGED_IN = {
  auth: true
}

const AUTH_ADMIN = {
  auth: 'ROLE_ADMIN'
}

Vue.router = new Router({
  mode: 'hash',
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition)
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 1000)
    })
  },
  routes: [
    {
      path: '/broadcasts/:id',
      name: 'broadcast',
      meta: AUTH_ADMIN,
      component: Broadcast
    },
    {
      path: '/epgs',
      name: 'epgs',
      meta: AUTH_LOGGED_IN,
      component: Epgs
    },
    {
      path: '/epgs/:id',
      name: 'epg',
      meta: AUTH_LOGGED_IN,
      component: Epg
    },
    {
      path: '/program',
      name: 'program',
      meta: AUTH_LOGGED_IN,
      component: TvProgram
    },
    {
      path: '/shows',
      name: 'shows',
      meta: AUTH_LOGGED_IN,
      component: Shows
    },
    {
      path: '/shows/:id',
      name: 'show',
      meta: AUTH_LOGGED_IN,
      component: Show
    },
    {
      path: '/labels',
      name: 'labels',
      meta: AUTH_ADMIN,
      component: Labels
    },
    {
      path: '/labels/:id',
      name: 'label',
      meta: AUTH_ADMIN,
      component: Label
    },
    {
      path: '/languages',
      name: 'languages',
      meta: AUTH_ADMIN,
      component: Languages
    },
    {
      path: '/languages/:id',
      name: 'language',
      meta: AUTH_ADMIN,
      component: Language
    },
    {
      path: '/countries',
      name: 'countries',
      meta: AUTH_ADMIN,
      component: Countries
    },
    {
      path: '/countries/:id',
      name: 'country',
      meta: AUTH_ADMIN,
      component: Country
    },
    {
      path: '/station-groups',
      name: 'station-groups',
      meta: AUTH_ADMIN,
      component: StationGroups
    },
    {
      path: '/station-groups/:id',
      name: 'station-group',
      meta: AUTH_ADMIN,
      component: StationGroup
    },
    {
      path: '/tv-stations',
      name: 'tv-stations',
      meta: AUTH_ADMIN,
      component: TvStations
    },
    {
      path: '/tv-stations/:id',
      name: 'tv-station',
      meta: AUTH_ADMIN,
      component: TvStation
    },
    {
      path: '/tv-channels',
      name: 'tv-channels',
      meta: AUTH_ADMIN,
      component: TvChannels
    },
    {
      path: '/tv-channels/:id',
      name: 'tv-channel',
      meta: AUTH_ADMIN,
      component: TvChannel
    },
    {
      path: '/epg-sources',
      name: 'epg-sources',
      meta: AUTH_ADMIN,
      component: EpgSources
    },
    {
      path: '/epg-sources/:id',
      name: 'epg-source',
      meta: AUTH_ADMIN,
      component: EpgSource
    },
    {
      path: '/crons',
      name: 'crons',
      meta: AUTH_ADMIN,
      component: Crons
    },
    {
      path: '/crons/:id',
      name: 'cron',
      meta: AUTH_ADMIN,
      component: Cron
    },
    {
      path: '/crons/:id/:idRun/:log',
      name: 'cron-run-log',
      meta: AUTH_ADMIN,
      component: CronRunLog
    },
    {
      path: '/image-sizes',
      name: 'image-sizes',
      meta: AUTH_ADMIN,
      component: ImageSizes
    },
    {
      path: '/image-sizes/:id',
      name: 'image-size',
      meta: AUTH_ADMIN,
      component: ImageSize
    },
    {
      path: '/users',
      name: 'users',
      meta: AUTH_ADMIN,
      component: Users
    },
    {
      path: '/users/:id',
      name: 'user',
      meta: AUTH_ADMIN,
      component: User
    },
    {
      path: '/settings',
      name: 'settings',
      meta: AUTH_ADMIN,
      component: Settings
    },
    {
      path: '/templates',
      name: 'templates',
      meta: AUTH_ADMIN,
      component: PairingTemplates
    },
    {
      path: '/video-qualities',
      name: 'video-qualities',
      meta: AUTH_ADMIN,
      component: VideoQualities
    },
    {
      path: '/vod/currencies',
      name: 'vodCurrencies',
      meta: AUTH_ADMIN,
      component: Currencies
    },
    {
      path: '/vod/currency/:id',
      name: 'vodCurrency',
      meta: AUTH_ADMIN,
      component: Currency
    },
    {
      path: '/vod/providers',
      name: 'vodProviders',
      meta: AUTH_ADMIN,
      component: Providers
    },
    {
      path: '/vod/provider/:id',
      name: 'vodProvider',
      meta: AUTH_ADMIN,
      component: Provider
    },
    {
      path: '/vod/videos',
      name: 'vodVideos',
      meta: AUTH_ADMIN,
      component: Videos
    },
    {
      path: '/vod/video/:id',
      name: 'vodVideo',
      meta: AUTH_ADMIN,
      component: Video
    },
    {
      path: '/vod/packages',
      name: 'vodPackages',
      meta: AUTH_ADMIN,
      component: Packages
    },
    {
      path: '/vod/package/:id',
      name: 'vodPackage',
      meta: AUTH_ADMIN,
      component: Package
    },
    {
      path: '/content-settings/backoffices',
      name: 'backoffices',
      meta: AUTH_ADMIN,
      component: Backoffices
    },
    {
      path: '/content-settings/backoffices/:id',
      name: 'backoffice',
      meta: AUTH_ADMIN,
      component: Backoffice
    },
    {
      path: '/content-settings/blackout-contents',
      name: 'blackoutContents',
      meta: AUTH_ADMIN,
      component: BlackoutContents
    },
    {
      path: '/content-settings/blackout-contents/:id',
      name: 'blackoutContent',
      meta: AUTH_ADMIN,
      component: BlackoutContent
    },
    {
      path: '/content-settings/blackout-content-templates',
      name: 'blackoutContentTemplates',
      meta: AUTH_ADMIN,
      component: BlackoutContentTemplates
    },
    {
      path: '/content-settings/blackout-content-templates/create/:id/:showId',
      name: 'blackoutContentTemplateNew',
      meta: AUTH_ADMIN,
      component: BlackoutContentTemplate
    },
    {
      path: '/content-settings/blackout-content-templates/:id',
      name: 'blackoutContentTemplate',
      meta: AUTH_ADMIN,
      component: BlackoutContentTemplate
    },
    {
      path: '/maturity-ratings',
      name: 'maturityRatings',
      meta: AUTH_ADMIN,
      component: MaturityRatings
    },
    {
      path: '/maturity-rating/:id',
      name: 'maturityRating',
      meta: AUTH_ADMIN,
      component: MaturityRating
    },
    {
      path: '*',
      name: 'index',
      component: Index
    }
  ]
})

export default Vue.router
